import decoder from '../../../lib/decoder';

function ModelPageNav() {
	this.page = 0;
	this.perPage = 0;
	this.count = 0;
}

ModelPageNav.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelPageNav();
	
	model.page = decoder.intValue(json['page'], 0);
	model.perPage = decoder.intValue(json['perPage'], 0);
	model.count = decoder.intValue(json['count'], 0);
	
	return model;
};

export default ModelPageNav;